import { toNumber } from './toNumber';

export function toPercentage(value: unknown): number | undefined {
  if (typeof value === 'number') {
    // toPrecision to avoid floating-point artifacts (e.g. 0.1 * 100 is 10.000000000000002)
    return Number.isFinite(value) ? Number.parseFloat((value * 100).toPrecision(10)) : undefined;
  }

  if (typeof value === 'string') {
    return toNumber(value);
  }

  return undefined;
}
